package com.kinoshazam.screens.allVideo.host

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.kinoshazam.screens.allVideo.compact.CompactAllVideosContent
import com.kinoshazam.screens.allVideo.expanded.ExpandedAllVideosWindow
import com.kinoshazam.screens.allVideo.medium.MediumAllVideosContent
import org.koin.compose.viewmodel.koinViewModel
import presentation.screens.allVideos.AllVideosViewModel
import utils.FormFactor

@Composable
fun AllVideosContentHost(
    formFactor: FormFactor,
) {
    val viewModel = koinViewModel<AllVideosViewModel>()
    val state by viewModel.state.collectAsStateWithLifecycle()

    when (formFactor) {
        FormFactor.Compact -> CompactAllVideosContent(
            state = state,
            onAction = viewModel::onAction,
        )

        FormFactor.Medium -> CompactAllVideosContent(
            state = state,
            onAction = viewModel::onAction,
        )

        FormFactor.Expanded -> MediumAllVideosContent(
            state = state,
            onAction = viewModel::onAction,
        )

        FormFactor.ExtraLarge -> ExpandedAllVideosWindow(
            state = state,
            onAction = viewModel::onAction,
        )
    }
}